import { z } from 'zod';
import { assigneeSchema, categorySchema, prioritySchema } from './enums.js';
// MoSCoW list item contract (SPEC §1.1, §3.4). A list item IS a map marker:
// when it has lat/lng it shows on the map; `assignee` is the form-facing value
// (joel | lea | both), mapped by the API to the nullable assigneeId.
const lat = z.number().min(-90).max(90);
const lng = z.number().min(-180).max(180);
// Links may be empty-string from a form; treat blank as "no link".
const optionalUrl = z
    .string()
    .trim()
    .max(2000)
    .url()
    .optional()
    .or(z.literal('').transform(() => undefined));
export const listItemCreateSchema = z.object({
    countryId: z.string(),
    priority: prioritySchema,
    category: categorySchema,
    title: z.string().trim().min(1, 'Title is required').max(200),
    note: z.string().max(2000).optional(),
    link: optionalUrl,
    assignee: assigneeSchema.optional(),
    done: z.boolean().optional(),
    lat: lat.optional(),
    lng: lng.optional(),
});
export const listItemUpdateSchema = z.object({
    priority: prioritySchema.optional(),
    category: categorySchema.optional(),
    title: z.string().trim().min(1).max(200).optional(),
    note: z.string().max(2000).nullable().optional(),
    link: z.string().trim().max(2000).url().nullable().optional(),
    assignee: assigneeSchema.optional(),
    done: z.boolean().optional(),
    order: z.number().int().optional(),
    // null on either clears the location (unplaces the marker).
    lat: lat.nullable().optional(),
    lng: lng.nullable().optional(),
});
/** Reorder / move within a single (country, priority) column. */
export const listItemReorderSchema = z.object({
    countryId: z.string(),
    priority: prioritySchema,
    orderedIds: z.array(z.string()),
});
export const listItemSchema = z.object({
    id: z.string(),
    tripId: z.string(),
    countryId: z.string(),
    priority: prioritySchema,
    category: categorySchema,
    title: z.string(),
    note: z.string().nullable(),
    link: z.string().nullable(),
    done: z.boolean(),
    assignee: assigneeSchema,
    voteJoel: z.boolean(),
    voteLea: z.boolean(),
    order: z.number().int(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=listItems.js.map